import { constants } from "./constants";
import { service } from "./service";
import { Dispatch } from "redux";

export const actions = {
  loginLexiaTools,
  logout,
  getUser,
};

// LOGIN
function loginLexiaTools(access_token, email) {
  const data = {
    token: access_token,
    email: email,
  };

  return function (dispatch) {
    dispatch(request());

    service.loginTools(data).then(
      function (data) {
        dispatch(success(data));
      },
      function failure(error) {
        return {
          type: constants.LOGIN_FAILURE,
          payload: JSON.stringify(error),
        };
      },
    );
  };

  function request() {
    return { type: constants.LOGIN_REQUEST };
  }

  function success(data) {
    return { type: constants.LOGIN_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: constants.LOGIN_FAILURE, payload: error };
  }
}

// LOGOUT
function logout() {
  return function (dispatch) {
    dispatch({ type: constants.LOGOUT_REQUEST });

    try {
      localStorage.clear();
      sessionStorage.clear();
      dispatch({ type: constants.LOGOUT_SUCCESS });
    } catch (error) {
      dispatch({
        type: constants.LOGOUT_FAILURE,
        payload: { error: "Errore durante il logout" },
      });
    }
  };
}

// GET USER

function getUser() {
  return async function (dispatch) {
    dispatch({ type: constants.GET_USER_REQUEST });
    try {
      const response = await service.getUser();
      dispatch({
        type: constants.GET_USER_SUCCESS,
        payload: response,
      });
      return response;
    } catch (error) {
      dispatch({
        type: constants.GET_USER_FAILURE,
        payload: error.message,
      });
      return null;
    }
  };
}
